import React from 'react';
import { IconProps } from '.';

const SvgEdit = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='m18.5.94 4.596 4.596L12.03 16.602l-4.52-.076-.076-4.52L18.5.939Zm0 2.12-9.556 9.556.04 2.435 2.435.04 9.556-9.555L18.5 3.06Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M2.25 2.25H12v1.5H3.75v16.5h16.5V12h1.5v9.75H2.25V2.25Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgEdit;
